module.exports = __webpack_public_path__ + "img/新能源发电.5e09865a.png";